var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 font-bold ds-text-base rounded-full w-full text-center select-none cursor-pointer transition-all duration-200",class:{
    'rounded-lg text-white': _vm.isActive,
    'bg-blue-300': _vm.isActive && _vm.secondTab,
    'bg-green-300': _vm.isActive && _vm.firstTab,
    'text-shadow': _vm.isActive && _vm.firstTab,
    'text-green-300': !_vm.isActive && _vm.secondTab,
    'text-blue-300': !_vm.isActive && _vm.firstTab,
    [`js-${_vm.id === 0 ? 'essentials': 'guidance'}-tab`]: true
  },on:{"click":function($event){return _vm.$emit('click', _vm.id)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }